export const CLIENT_ID = 'Lmafo8GvkSnPwbek';
export const PORTAL_URL = 'https://qaext.arcgis.com/sharing/rest';
export const LOCAL_STORAGE_KEY = `__CONTEXT_${CLIENT_ID}`;
export const SITE_ID = '2b90df90e70549c1a256ebb6230f7451'; // brollywood: d4f484fe02324aaf86c4275a5ee72d3e